import { Base2Presenter } from "core/presenter";
import { DiscountRepository } from "core/repository";
import { DiscountConstraint } from "core/constraint";
import { Discount } from "core/entity";
import validate from "util/validate";
class DiscountFormCreatePresenter extends Base2Presenter {
  initialState() {
    return {
      creating: true,
      loading: true,
      form: new Discount(),
      errors: {},
      title: "Novo Desconto"
    };
  }

  async onStart() {
    this.enqueue({ loading: true });

    await this.loadDiscount();

    this.enqueue({ loading: false });
  }

  async loadDiscount() {
    const discountResult = await this.getDiscount();
    if (discountResult.success) {
      this.enqueue({ form: discountResult.data });
    } else {
      this.sendNotification({
        type: "error",
        title: "Ooops",
        content:
          "Houve um problema ao carregar as informações do desconto. Por favor, tente novamente daqui uns minutos ou entre em contato com o suporte."
      });
    }
  }

  getDiscount() {
    return { success: true, data: new Discount() };
  }

  async onSendForm() {
    this.enqueue({ loading: true });

    const { form, creating } = this.viewModel;

    const errors = this.validateForm(form);

    if (Object.keys(errors).length === 0) {
      const response = await this.callRepository(this.viewModel.form);
      if (response.success) {
        this.sendNotification({
          type: "success",
          content: !!creating
            ? "Desconto criado com sucesso!"
            : "Desconto atualizado com sucesso!"
        });

        return this.navigateTo("app.registration.discount");
      } else if (response.error) {
        this.sendNotification({
          type: "error",
          title: "Oops...",
          content:
            "Ocorreu um problema ao salvar o desconto. Verifique os dados informados e se os campos marcados com * estão preenchidos."
        });
      } else {
        this.sendNotification({
          type: "error",
          title: "Oops...",
          content:
            "Ocorreu um problema ao salvar o desconto. Por favor, tente novamente mais tarde ou entre em contato com o suporte."
        });
      }
    } else {
      this.enqueue({ errors });

      this.sendNotification({
        type: "error",
        title: "Ooops",
        content:
          "Ocorreu um problema ao salvar o desconto. Verifique os dados informados e se os campos marcados com * estão preenchidos."
      });
    }

    this.enqueue({ loading: false });
  }

  validateForm(params) {
    const errors = {};

    const validation = validate(params, DiscountConstraint.save, {
      fullMessages: false
    });
    if (!!validation) {
      Object.entries(validation)
        .map(([field, errors]) => ({ field, content: errors.join(", ") }))
        .forEach(({ field, content }) => (errors[field] = content));
    }

    return errors;
  }

  async callRepository(params) {
    return await DiscountRepository.create(params);
  }

  onChange(field, value) {
    this.enqueue(vm => ({
      form: {
        ...vm.form,
        [field]: value
      }
    }));
  }

  onGoBack() {
    this.navigateTo("app.registration.discount");
  }
}

export default DiscountFormCreatePresenter;



// WEBPACK FOOTER //
// ./src/components/app/registration/discount/form/create.presenter.js